import React from 'react';
import {format, parseISO} from "date-fns";


export function DateTime(props: {
  date: string|Date
}) {
  const date = typeof props.date === 'string' ? parseISO(props.date) : props.date;
  return <>{format(date, 'yyyy-MM-dd HH:mm')}</>;
}